import type React from "react";
import { useDrag } from "react-dnd";

type Props = {
	wordObj: { word: string; index: number };
	arrayOfWords: { word: string; index: number }[];
};

export const Word: React.FC<Props> = ({ wordObj, arrayOfWords }) => {
	const [{ isDragging }, drag] = useDrag({
		type: "unscramble",
		item: wordObj,
		canDrag: () => arrayOfWords[wordObj.index].word !== "",
		collect: (monitor) => ({
			isDragging: !!monitor.isDragging(),
		}),
	});

	return (
		<div
			className="unscramble-activity__word-item"
			ref={drag}
			style={{
				opacity: isDragging ? 0.5 : 1,
			}}
		>
			<p>{wordObj.word}</p>
		</div>
	);
};
